module.exports = __webpack_public_path__ + "static/media/The-Ultimate-Guide-to-Sell-Car-in-brisbane.308b3c7c.jpg";